import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export function login(loginData) {
    return http.post(API_PATHS.login, loginData);
}
